// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"Pin_pattern-gradient__38EIa","page":"Pin_page__flrbc"};